// DS5.1
import React from 'react';
import c from 'classnames';
import { useTranslation } from 'react-i18next';
import { BiEventType, BiDataHook, ReferralType, } from '@wix/da-bi/pkg/constants';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks/useFlag';
import { Url, URLS } from '@wix/da-url';
import Logo from '@wix/da-ds/pkg/Logo';
import TextButton from '@wix/da-ds/pkg/Buttons/TextButton';
import BiLink from '@wix/da-bi/pkg/Components/BiLink';
import { BiData, } from '@wix/da-bi/pkg/events';
import DealerAd from '../../DealerAd';
import ErrorBoundary from '../../ErrorBoundary';
import HeaderSearchInput from '../_partials/HeaderSearchInput';
import Burger from '../_partials/Burger';
import CartIconButton from '../_partials/CartIconButton';
import SubmitMenu from '../../SiteHeader/SiteHeaderDesktop/SubmitMenu';
import UserDropdownMenu from '../../SiteHeader/SiteHeaderDesktop/UserDropdownMenu';
import s from './SiteHeaderDesktop.scss';
var DEALER_PROD_REALESTATEID = '9c14ea7a-8c35-429a-9857-00ad04ebb4c1';
var DEALER_JSON_REALESTATEID = '83868b70-2beb-444a-ab30-3633acc41d33';
var SiteHeader = function (_a) {
    var hasCoreMembership = _a.hasCoreMembership, isLoggedIn = _a.isLoggedIn, isLegacyHeader = _a.isLegacyHeader, _b = _a.showNetworkBar, showNetworkBar = _b === void 0 ? true : _b, cartCount = _a.cartCount;
    var t = useTranslation().t;
    var dealerJson = useFlag('dealer_json_offer');
    return (React.createElement(ErrorBoundary, { debugComponent: "SiteHeaderDesktop" },
        React.createElement("header", { role: "banner", "data-hook": BiDataHook.TOP_NAV, className: s['root'] },
            React.createElement(Burger, { showNetworkBar: showNetworkBar, iconClassName: s['icon'] }),
            React.createElement(BiLink, { biData: BiData({
                    evid: 700,
                    link_url: Url.buildFromPath(URLS.ROOT),
                    link_name: 'logo',
                }), href: Url.buildFromPath(URLS.ROOT), "aria-label": t('siteHeader.a11y.home'), className: s['logo-link'] },
                React.createElement(Logo, { size: "tiny", className: s['logo'], markColorClassname: s['logo-mark-color'], textColorClassname: s['logo-text-color'] })),
            React.createElement(TextButton, { size: "medium", variant: "main", className: c(s['text-button'], s['regular-text-button']) }, t('siteHeader.watch')),
            React.createElement(TextButton, { size: "medium", variant: "main", className: c(s['text-button'], s['regular-text-button']) }, t('siteHeader.shop')),
            !hasCoreMembership && (React.createElement(TextButton, { size: "small", variant: 'core-orange', className: c(s['text-button'], s['upgrade-to-core'], isLoggedIn && s['upgrade-to-core-loggedin']), href: URLS.CORE_MEMBERSHIP, biData: BiData({
                    evid: 375,
                    referral_info: ReferralType.HEADER,
                }) }, t('siteHeader.upgradeToCore'))),
            React.createElement(HeaderSearchInput, { className: s['search-input'] }),
            React.createElement("div", { className: s['right-side'] },
                React.createElement(DealerAd, { realEstateId: dealerJson ? DEALER_JSON_REALESTATEID : DEALER_PROD_REALESTATEID, className: s['ad-slot'] }),
                !isLoggedIn && (React.createElement(React.Fragment, null,
                    React.createElement(TextButton, { size: "small", variant: "main", biData: {
                            evid: BiEventType.REDIRECT_TO_LOGIN,
                            referral_info: ReferralType.HEADER,
                        }, className: s['text-button'], href: Url.joinLink() }, t('siteHeader.join')),
                    React.createElement(TextButton, { size: "small", variant: "main", biData: BiData({
                            evid: 700,
                            link_url: Url.loginLink(),
                            link_name: 'login',
                        }), className: s['text-button'], href: Url.loginLink() }, t('siteHeader.signIn')))),
                cartCount > 0 && (React.createElement(CartIconButton, { className: s['icon-button'], cartCount: cartCount, iconClassName: s['icon'], numberClassName: s['number'] })),
                React.createElement("div", { className: s['user-icon-button-wrapper'] },
                    React.createElement(UserDropdownMenu, { isOpen: false, className: s['icon-submenu'], disableThemeSwitcher: false, isLegacyHeader: isLegacyHeader })),
                React.createElement(SubmitMenu, { isOpen: false, className: c(s['icon-button-has-submenu'], s['icon-button-has-submit-submenu']), menuClassName: s['icon-submenu'], isLegacyHeader: false })))));
};
SiteHeader.displayName = 'SiteHeader';
export default SiteHeader;
//# sourceMappingURL=SiteHeaderDesktop.js.map